export default "__VITE_ASSET__Ba8CNWk4__"